import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {Category} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/category.types';
import {CategoryNavigationService_GetNavigationHeaderLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/navigation/service.grpc.lazy';
import {
  excludeQueryParams,
  useHistory,
  useInitialPageType,
  useIsDirectEntryPageType,
  useQueryParams,
} from '@aboutyou/router';
import {useCustomerSession} from '@aboutyou/user';
import {useAnyFilterFlyoutOpened} from '../../../features/Filters/shared/useAnyFilterFlyoutOpened';
import {useAppliedPotentialFilters} from '../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {
  useAppliedQuickFilter,
  useCategoryCacheKeyTransformer,
  useCategoryIdentifier,
} from '../utils';

export const useHeaderData = () => {
  const appliedFilters = useAppliedPotentialFilters();
  const appliedQuickFilter = useAppliedQuickFilter();
  const categoryCacheKeyTransformer = useCategoryCacheKeyTransformer();
  const categoryIdentifier = useCategoryIdentifier();
  const isFilterFlyoutOpen = useAnyFilterFlyoutOpened();
  const targetGroup = useTargetGroupIdentifier();
  const customerSession = useCustomerSession();

  return useGrpcRequest(
    CategoryNavigationService_GetNavigationHeaderLazy,
    {
      appliedFilters: {
        filters: appliedFilters,
        quickFilter: appliedQuickFilter,
      },
      category: {
        identifier: categoryIdentifier,
      },
      reductionsState: useReductionsStateRequestParameter(),
      targetGroup,
      session: customerSession || null,
      sortOptions: null,
    },
    {
      disabled: isFilterFlyoutOpen,
      keepPreviousData: true,
      transformCacheKey: categoryCacheKeyTransformer,
    },
  );
};

const PARAMS_TO_EXCLUDE = new Set(['page']);
export const useNormalizedHeaderData = ({
  category,
  parentCategory,
  alternativeSeoCategoryName,
}: {
  category?: Category;
  parentCategory?: Category;
  alternativeSeoCategoryName?: string | undefined;
}) => {
  const initialPageType = useInitialPageType();
  const isDirectEntryPageType = useIsDirectEntryPageType();
  const queryParams = useQueryParams();
  const {goBack} = useHistory();
  const categoryName = alternativeSeoCategoryName || category?.name;
  const basePath = parentCategory?.path ?? '/';
  const isCategoryInitialPage = initialPageType === 'category';

  /**
   * the category button back should always use the history back, except for when the user
   * initial page type is a Category.
   * - When the category page is the first page type: to allow the user to to the parents
   * category in case they land on a subcategory page, then if no parent category is present,
   * the user is sent to the browse page
   */
  const shouldGoToParentCategory =
    isDirectEntryPageType && isCategoryInitialPage;

  const backPath =
    queryParams.size > 0
      ? `${basePath}?${excludeQueryParams(queryParams, PARAMS_TO_EXCLUDE)}`
      : basePath;

  return {
    backPath: shouldGoToParentCategory ? backPath : undefined,
    onBack: shouldGoToParentCategory ? undefined : goBack,
    categoryName,
  };
};
